import $ from 'jquery';

import mq from '../utils/media-queries';

export default {

  _bindEvents() {
    mq.onMaxWidth(768, () => this.abbreviate() );
  },

  init() {
    this._bindEvents();
  },

  abbreviate() {
    $('.embed-events thead').find('[data-day-abbr]').each( function(i) {
      $(this).text( $(this).data('day-abbr') );
    });
  },
}
